// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, createActionsHook } from '@atlassian/react-sweet-state';
import type { LayoutState } from '../../../common/types.tsx';
import { actions, type LayoutActions } from '../actions/index.tsx';

export const DEFAULT_LEFT_SIDEBAR_WIDTH = 240;
export const DEFAULT_RIGHT_SIDEBAR_WIDTH = 0;
export const DEFAULT_PREVIEW_PANEL_WIDTH = 400;

const initialState: LayoutState = {
	isChromeless: false,
	isFullscreen: false,
	banner: { height: 0, activeBanner: null },
	topNavigation: { isVisible: true },
	leftPanel: { isVisible: true, width: 0 },
	rightPanel: { isVisible: true, width: 0 },
	bottomRightCorner: { container: undefined, portals: [] },
	content: {
		leftSidebar: {
			width: DEFAULT_LEFT_SIDEBAR_WIDTH,
			isCollapsed: true,
			isVisible: true,
			isFlyoutOpen: false,
			hasUserPreference: false,
		},
		rightSidebar: {
			stackState: [],
		},
		previewPanel: {
			width: DEFAULT_PREVIEW_PANEL_WIDTH,
		},
	},
};

export const layoutStore = createStore<LayoutState, LayoutActions>({
	initialState,
	actions,
	name: 'JiraLayoutStore',
});

export const useLayoutStoreActions = createHook(layoutStore, {
	selector: null,
});

const detailPanelWidthStore = createStore({
	name: 'detailPanelWidth',
	initialState: {
		width: 0,
	},
	actions: {
		setWidth:
			(value: number) =>
			({ setState }) => {
				setState({ width: value });
			},
	},
});

export const useDetailPanelWidth = createHook(detailPanelWidthStore);
export const useDetailPanelActions = createActionsHook(detailPanelWidthStore);
